<section class="container" [formGroup]="form">
  <div class="card shadow-sm">
    <div class="card-header">
      <h1 class="card-title font-weight-semibold">
        <a routerLink="/rota-volta" class="text-dark mr-2">
          <i class="fa fa-arrow-left"></i>
        </a>
        <span>Download de XMLs do Sagres</span>
      </h1>
    </div>

    <div class="card-body">
      <div class="row align-items-start">
        <div class="col-md-6 form-group">
          <label>Competência *</label>
          <select class="form-control shadow-sm" formControlName="competencia">
            <option value="">Selecione...</option>
            <option *ngFor="let comp of competencias; trackBy: trackByValor" [value]="comp.VALOR">
              {{ comp.DESCRICAO }}
            </option>
          </select>
          <small class="text-muted" *ngIf="form.get('competencia')?.valid">
            Sigla: <strong>{{ sigla }}</strong> | Filial: <strong>{{ empfil }}</strong>
          </small>

          <div class="error-container" [style.min-height]="temErro('competencia') ? '25px' : '0'">
            <div *ngIf="temErro('competencia')" class="text-danger small mt-1">
              {{ getMensagemErro('competencia') }}
            </div>
          </div>
        </div>

        <div class="col-md-6 form-group">
          <label class="invisible">Botão</label>
          <div class="d-flex align-items-center h-100">
            <button
              type="button"
              class="btn btn-primary w-100"
              [disabled]="form.invalid || baixando"
              (click)="baixarTodosXMLs()"
              style="height: 38px"
            >
              <span *ngIf="!baixando">Baixar Todos XMLs</span>
              <span *ngIf="baixando">
                <i class="fa fa-spinner fa-spin mr-1"></i>
                Baixando...
              </span>
            </button>
          </div>

          <div class="error-container" style="min-height: 25px; visibility: hidden">&nbsp;</div>
        </div>
      </div>

      <div class="mt-4">
        <h2>Arquivos XML Disponíveis</h2>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Arquivo XML</th>
                <th>Registros</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let xml of xmls; trackBy: trackByNome">
                <td>
                  <i class="fa fa-file-code-o text-info mr-2"></i>
                  {{ xml.nome }}
                </td>
                <td>
                  <span *ngIf="xml.regs !== undefined && xml.regs > 0" class="badge badge-info">
                    {{ xml.regs }}
                  </span>
                  <span
                    *ngIf="xml.regs === 0 || xml.status === 'erro'"
                    class="badge badge-secondary"
                  >
                    0 regs
                  </span>
                  <span
                    *ngIf="xml.regs === undefined && xml.status !== 'concluido'"
                    class="badge badge-light"
                  >
                    -
                  </span>
                </td>
                <td>
                  <span *ngIf="xml.status === 'pendente'" class="badge badge-secondary">
                    Pendente
                  </span>
                  <span *ngIf="xml.status === 'baixando'" class="badge badge-warning">
                    <i class="fa fa-spinner fa-spin mr-1"></i>
                    Baixando
                  </span>
                  <span *ngIf="xml.status === 'concluido'" class="badge badge-success">
                    <i class="fa fa-check mr-1"></i>
                    Concluído
                  </span>
                  <span *ngIf="xml.status === 'erro'" class="badge badge-danger" [title]="xml.erro">
                    <i class="fa fa-times mr-1"></i>
                    Erro
                  </span>
                </td>
                <td>

                  <small *ngIf="xml.erro" class="text-danger" style="font-size: 0.8rem;">
                    {{ xml.erro }}
                  </small>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="mt-4" *ngIf="progresso.total > 0">
        <div class="card">
          <div class="card-body text-center">
            <div class="row align-items-center justify-content-center">
              <div class="col-md-8">
                <h3 class="mb-3">Progresso do Download</h3>
                <div class="progress mb-2" style="height: 25px">
                  <div
                    class="progress-bar"
                    [class]="getProgressBarClass()"
                    [style.width]="progresso.percentual + '%'"
                    role="progressbar"
                    [attr.aria-valuenow]="progresso.percentual"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {{ progresso.percentual }}%
                  </div>
                </div>
                <small class="text-muted">
                  {{ progresso.concluidos }} de {{ progresso.total }} arquivos baixados
                </small>

                <div class="mt-4" *ngIf="progresso.concluidos > 0">
                  <button
                    type="button"
                    class="btn btn-success btn-lg px-5"
                    [disabled]="!todosBaixados || gerandoZip"
                    (click)="gerarZip()"
                  >
                    <span *ngIf="!gerandoZip">
                      <i class="fa fa-file-archive-o mr-2"></i>
                      Baixar ZIP com Todos XMLs
                    </span>
                    <span *ngIf="gerandoZip">
                      <i class="fa fa-spinner fa-spin mr-2"></i>
                      Gerando ZIP...
                    </span>
                  </button>

                  <div *ngIf="!todosBaixados" class="mt-2">
                    <small class="text-warning">
                      <i class="fa fa-info-circle mr-1"></i>
                      Aguarde todos os arquivos serem baixados para gerar o ZIP
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="todosBaixados && !gerandoZip" class="alert alert-success mt-3">
        <i class="fa fa-check-circle mr-2"></i>
        Todos os arquivos foram baixados com sucesso! Clique em "Baixar ZIP" para obter todos os
        XMLs em um único arquivo.
      </div>
    </div>
  </div>

  <div
    class="card shadow-sm mt-4"
    *ngIf="
      (folhaPagamentoContent.length > 0 || vantagemDescontoContent.length > 0) && todosBaixados
    "
  >
    <div class="card-header">
      <h3 class="card-title font-weight-semibold">Resumo SAGRES</h3>
    </div>
    <div class="card-body">
      <!-- Tabela Folha de Pagamento -->
      <div *ngIf="folhaPagamentoContent.length > 0">
        <h4 class="text-primary">Folha de Pagamento</h4>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Tipo Folha Sagres</th>
                <th>Processamento</th>
                <th>Vínculo</th>
                <th>Base Calc Prev Servidor</th>
                <th>Base Calc Prev Patronal</th>
                <th>Base Calculo IR</th>
                <th>Alícota Desc Prev Servidor</th>
                <th>Alícota Desc Prev Patronal</th>
                <th>Valor Desc Prev Patronal (R$)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of folhaPagamentoContent; let i = index">
                <td>{{ item.TipoFolhaSagres || 'N/A' }}</td>
                <td>{{ item.Processamento || 'N/A' }}</td>
                <td>
                  {{ (item.CodVinculo || '') + ' - ' + (item.DescVinculo || '') }}
                </td>
                <td>{{ item.BaseCalcPrevServidor || '0,00' }}</td>
                <td>{{ item.BaseCalcPrevPatronal || '0,00' }}</td>
                <td>{{ item.BaseCalculoIR || '0,00' }}</td>
                <td>{{ item.AlicotaDescPrevServidor || '0,00' }}</td>
                <td>{{ item.AlicotaDescPrevPatronal || '0,00' }}</td>
                <td>{{ item.ValorDescPrevPatronal || '0,00' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Tabela Vantagem e Desconto -->
      <div
        *ngIf="vantagemDescontoContent.length > 0"
        [class.mt-4]="folhaPagamentoContent.length > 0"
      >
        <h4 class="text-primary">Vantagem e Desconto</h4>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Tipo Folha</th>
                <th>Código Sagres</th>
                <th>Código Verba</th>
                <th>Nome Verba</th>
                <th>Total (R$)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of vantagemDescontoContent; let i = index">
                <td>{{item.TipoFolha || 'N/A'}}</td>
                <td>{{ item.CodigoSagres || 'N/A' }}</td>
                <td>{{ item.CodigoVerba || 'N/A' }}</td>
                <td>{{ item.NomeVerba || 'N/A' }}</td>
                <td>{{ item.Total || '0,00' }}</td>
              </tr>
            </tbody>
          </table>
          <div class="mt-3 p-3 border rounded bg-light" *ngIf="vantagemDescontoTotais">
            <div class="row text-center fw-bold">
              <div class="col-md-4">
                <span>Total Vantagens: </span>
                <span class="text-success ms-2">R$ {{ vantagemDescontoTotais?.vantagens || '0,00' }}</span>
              </div>
              <div class="col-md-4">
                <span>Total Descontos: </span>
                <span class="text-danger ms-2">R$ {{ vantagemDescontoTotais?.descontos || '0,00' }}</span>
              </div>
              <div class="col-md-4">
                <span>Total Líquido: </span>
                <span class="text-primary ms-2">R$ {{ vantagemDescontoTotais?.diferenca || '0,00' }}</span>
              </div>
            </div>
          </div>
          
        </div>
      </div>

      <!-- Tabela Servidores -->
      <div
      *ngIf="servidoresContent.length > 0"
      [class.mt-4]="folhaPagamentoContent.length > 0 || vantagemDescontoContent.length > 0"
    >
      <h4 class="text-primary">Servidores</h4>
    
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>CPF</th>
              <th>Nome</th>
              <th>Sexo</th>
              <th>Data Nascimento</th>
            </tr>
          </thead>
    
          <tbody>
            <tr *ngFor="let item of servidoresContent; let i = index">
              <td>{{ formatarCPF(item.CPFServidor) }}</td>
              <td>{{ item.NomeServidor }}</td>

              <td>
                {{
                  item.Sexo?.toUpperCase() === 'M' ? 'Masculino'
                  : item.Sexo?.toUpperCase() === 'F' ? 'Feminino'
                  : 'N/A'
                }}
              </td>

              <td>{{ formatarData(item.DataNascimento) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    <div *ngIf="dependentesContent.length > 0" class="mt-4">
      <h4 class="text-primary">Dependentes</h4>
    
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>CPF Servidor</th>
              <th>Nome</th>
              <th>CPF Dependente</th>
              <th>Parentesco</th>
              <th>Data Nasc.</th>
              <th>Data Inclusão</th>
            </tr>
          </thead>
    
          <tbody>
            <tr *ngFor="let d of dependentesContent; let i = index">

              <td>
                <ng-container *ngIf="mostrarCPFServidor(d.CPFServidor)">
                  {{ formatarCPF(d.CPFServidor) }}
                </ng-container>
              </td>

              <td>{{ d.Nome }}</td>

              <td>{{ formatarCPF(d.CPFDependente) }}</td>
    
              <td>{{ getParentesco(d.RelacaoParentesco) }}</td>
    
              <td>{{ formatarData(d.DataNascimento) }}</td>
    
              <td>{{ formatarData(d.DataInclusaoDependente) }}</td>
    
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    


    </div>
  </div>
</section>
